export default "__VITE_ASSET__DX6unLZG__"